/**
 * @module Cohesion Server Side Cookie Setting
 * @description Core Web Vitals Reporting
 */

import { getCookie } from "@/js/utils/cookie";

/**
 * @function sendToAnalytics
 * @description Track server side cookie setting value via Tagular.
 *
 * @return {void}
 */
const sendSscEvent = () => {
  const value = getCookie("tglr_ssc") || "0";

  cohesion("ready", () => {
    // Beam server side cookie test.
    tagular("beam", {
      "@type": "redventures.browser.v1alpha.CookieIdentified",
      key: "tglr_ssc",
      value,
    });
  });
};

export default sendSscEvent;
